<template>
  <el-dialog :visible.sync="dialogVisible" title="退款" center width="570px">
    <el-form ref="refundModal1" :model="form" label-suffix=":" class="payFormModal" label-width="110px" :rules="rules">
      <div v-for="(mch_list, index) in form.mch_list" :key="mch_list.mch_id">
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户号">{{ mch_list.mch_id }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="商户号余额"
              :prop="'mch_list.' + index + '.price'"
              :rules="[{
                required: true, message: '金额不能为空', trigger: 'blur'
              }, {validator: (rule, value, callback) => validatorFn(rule, value, callback, index), trigger: 'blur'}]"
            >
              <el-input v-model="mch_list.price" class="w150" @input="changeFn" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="服务费率">{{ source.rate }}%</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实际退款金额">￥{{ refundAll }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="收款人" prop="user">
            <el-input v-model="form.user" class="w150" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="form.bank" class="w150" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mb15">
        <el-col :span="12">
          <el-form-item label="银行卡号" prop="bank_card">
            <el-input v-model="form.bank_card" class="w200" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template v-slot:footer class="text-center">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitForm('refundModal1')">确定</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    source: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      copyList: [], // 比对原始数据备份
      form: {
        user: '',
        bank: '',
        bank_card: '',
        mch_list: []
      },
      rules: {
        user: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ],
        bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bank_card: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    refundAll() {
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      return this.toDecimal(this.add(this.mul(sum, this.source.rate / 100), sum))
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
    dialogVisible(value) {
      if (!value) {
        // 重置
        this.form.user = ''
        this.form.bank = ''
        this.form.bank_card = ''
        this.form.mch_list = []
        this.$emit('update:visible', false)
      }
    },
    source: {
      handler(val) {
        if (val && val.mch_list && val.mch_list.length) {
          val.mch_list.forEach(item => {
            this.form.mch_list.push({
              mch_id: item.mch_id,
              price: +item.prcie / 100
            })
            this.copyList.push({
              mch_id: item.mch_id,
              price: +item.prcie / 100
            })
          })
        }
      },
      deep: true
    }
  },
  methods: {
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate()
      if (!valid) return
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      if (+sum <= 0) {
        this.$message.error('所有商户号退款金额之和必须大于零!')
        return
      }
      this.$emit('passFn', this.form)
    },
    changeFn(val) {
      this.form.recharge_price = val.replace(/[^\d\.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    validatorFn(rule, value, callback, index) {
      // if (+this.copyList[index].price === 0) {
      //   callback(new Error(`当前商户号没有可退余额`))
      // } else if (+value <= 0) {
      //   callback(new Error('退款金额必须大于0'))
      // } else if (+value > this.copyList[index].price) {
      //   callback(new Error(`金额不能比${this.copyList[index].price}大`))
      // } else {
      //   callback()
      // }
      if (+value > this.copyList[index].price) {
        callback(new Error(`金额不能比${this.copyList[index].price}大`))
      } else {
        callback()
      }
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep{
  .el-form-item{
    margin-bottom: 18px;
  }
}
</style>
